module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("efLyD"))).then(() => module.bundle.root('iDabs'));